import getOriginalSignFieldDimensions from './getOriginalSignFieldDimensions';

const reduceImage = (imageHeight, imageWidth, requestHeight, requestWidth) => {
  const aspectRatio = imageWidth / imageHeight;
  let width = Math.min(imageWidth, requestWidth);
  let height = width / aspectRatio;
  if (height > requestHeight) {
    height = requestHeight;
    width = aspectRatio * height;
  }
  return { aspectRatio, height, width };
};

const expandImage = (imageHeight, imageWidth, requestHeight, requestWidth) => {
  const aspectRatio = imageWidth / imageHeight;
  let width = Math.max(imageWidth, requestWidth);
  let height = width / aspectRatio;
  if (height > requestHeight) {
    height = requestHeight;
    width = aspectRatio * height;
  }
  return { aspectRatio, height, width };
};

/**
 * Calculate the largest possible rect that fits within the request field area and matches the
 * image's aspect ratio.
 * @param loadEvent the event object passed to IMG onLoad
 * @param popup the signature popup being filled
 * @returns {{aspectRatio, height, width}}
 */
const calculatePopupImageDimensions = ({ loadEvent, popup }) => {
  const { height: requestHeight, width: requestWidth } = getOriginalSignFieldDimensions(popup);
  const { height: imageHeight, width: imageWidth } = loadEvent.target;
  if ((imageHeight > requestHeight) || (imageWidth > requestWidth)) {
    return reduceImage(imageHeight, imageWidth, requestHeight, requestWidth);
  }
  return expandImage(imageHeight, imageWidth, requestHeight, requestWidth);
};

export default calculatePopupImageDimensions;



// WEBPACK FOOTER //
// ./src-react/Popups/helpers/calculatePopupImageDimensions.jsx